import Parse from "parse";

import type { Category } from "./Category";

type OD3_Language = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface ArticleAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  category: Category;
  label: string;
  language: OD3_Language;
  markdown: string;
  tenant: OD3_Tenant;
}

export class Article extends Parse.Object<ArticleAttributes> {
  static className: string = "OD3_Knowledge_Article";

  constructor(data?: Partial<ArticleAttributes>) {
    super("OD3_Knowledge_Article", data as ArticleAttributes);
  }

  get category(): Category {
    return super.get("category");
  }
  set category(value: Category) {
    super.set("category", value);
  }
  get label(): string {
    return super.get("label");
  }
  set label(value: string) {
    super.set("label", value);
  }
  get language(): OD3_Language {
    return super.get("language");
  }
  set language(value: OD3_Language) {
    super.set("language", value);
  }
  get markdown(): string {
    return super.get("markdown");
  }
  set markdown(value: string) {
    super.set("markdown", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_Knowledge_Article", Article);
